// GENERATED by scripts/colors/generate-palette.ts — DO NOT EDIT.
// Source of truth: styles/tokens/palette.source.ts. Re-run the generator to update.
import type { MantineColorsTuple } from "@mantine/core";

/** Resolved sRGB hex, as Mantine 10-step tuples. Consumed by the theme + (bridged) SCSS/TS. */
export const palette = {
  primary: [
    "#FDFAE8",
    "#FAF0C5",
    "#F8E399",
    "#F6D25E",
    "#F6D125",
    "#DCB320",
    "#BE9A1C",
    "#A2831A",
    "#856A18",
    "#695215",
  ] as unknown as MantineColorsTuple,
  secondary: [
    "#D7ECF7",
    "#A7D6F0",
    "#71BFEA",
    "#38A7E0",
    "#2C90D3",
    "#2179B4",
    "#196494",
    "#135075",
    "#0D3C58",
    "#08283C",
  ] as unknown as MantineColorsTuple,
  neutral: [
    "#FDFDFC",
    "#F7F6F3",
    "#ECEBE6",
    "#DDDBD9",
    "#C8C6C4",
    "#9F9D9B",
    "#787774",
    "#535250",
    "#42403E",
    "#2A2927",
  ] as unknown as MantineColorsTuple,
  success: [
    "#CFECD4",
    "#A6D9B0",
    "#82C393",
    "#5EAC77",
    "#3D955A",
    "#2C824A",
    "#1E6D3C",
    "#145830",
    "#0D4425",
    "#073118",
  ] as unknown as MantineColorsTuple,
  error: [
    "#FFE3E0",
    "#FAC3BD",
    "#FD9C94",
    "#FC706A",
    "#EA4C4B",
    "#CF3034",
    "#B21120",
    "#8D0B17",
    "#6B060F",
    "#4A0307",
  ] as unknown as MantineColorsTuple,
  orange: [
    "#FBEBDC",
    "#FAD3B0",
    "#F8B67F",
    "#F7974C",
    "#FF8100",
    "#E9701A",
    "#CE5F14",
    "#AF4F12",
    "#92400F",
    "#74320C",
  ] as unknown as MantineColorsTuple,
  white: "#FFFFFF",
  black: "#000000",
} as const;

/** OKLCH form, derived from the hex above. For the future `--color-*` runtime layer. */
export const paletteOklch = {
  primary: [
    "oklch(0.9826 0.0238 99.1)",
    "oklch(0.9523 0.0567 96.42)",
    "oklch(0.9163 0.0957 94.14)",
    "oklch(0.8728 0.1393 92.01)",
    "oklch(0.867 0.1711 95.37)",
    "oklch(0.7814 0.153 91.25)",
    "oklch(0.6997 0.1363 90.98)",
    "oklch(0.6221 0.1196 90.74)",
    "oklch(0.5365 0.1007 89.2)",
    "oklch(0.4508 0.0819 87.06)",
  ],
  secondary: [
    "oklch(0.9309 0.0268 230.36)",
    "oklch(0.8517 0.0609 232.61)",
    "oklch(0.7707 0.0987 234.19)",
    "oklch(0.6913 0.1284 235.79)",
    "oklch(0.6284 0.1346 243.22)",
    "oklch(0.5545 0.1215 243.58)",
    "oklch(0.4831 0.1041 242.5)",
    "oklch(0.4127 0.0858 240.92)",
    "oklch(0.3404 0.0691 240.18)",
    "oklch(0.265 0.0522 240.62)",
  ],
  neutral: [
    "oklch(0.9938 0.0013 106.42)",
    "oklch(0.9731 0.0041 91.45)",
    "oklch(0.9394 0.0068 97.36)",
    "oklch(0.8924 0.0035 67.78)",
    "oklch(0.8276 0.0036 67.77)",
    "oklch(0.6971 0.0037 67.76)",
    "oklch(0.5692 0.0047 91.48)",
    "oklch(0.4389 0.0035 84.57)",
    "oklch(0.3728 0.0043 67.69)",
    "oklch(0.2812 0.0039 84.58)",
  ],
  success: [
    "oklch(0.9154 0.0444 150.33)",
    "oklch(0.8386 0.0777 150.39)",
    "oklch(0.7603 0.0957 151.85)",
    "oklch(0.6799 0.1107 152.83)",
    "oklch(0.6009 0.1233 151.68)",
    "oklch(0.5406 0.1195 151.58)",
    "oklch(0.4747 0.1089 152.02)",
    "oklch(0.4082 0.094 152.83)",
    "oklch(0.343 0.0778 153.73)",
    "oklch(0.2775 0.0644 152.65)",
  ],
  error: [
    "oklch(0.9379 0.0312 25.03)",
    "oklch(0.8645 0.0639 25.63)",
    "oklch(0.7898 0.1174 25.13)",
    "oklch(0.7136 0.1726 24.87)",
    "oklch(0.6376 0.1948 24.87)",
    "oklch(0.5623 0.1951 25.05)",
    "oklch(0.4869 0.1892 24.98)",
    "oklch(0.4103 0.1594 25.02)",
    "oklch(0.3365 0.1308 24.95)",
    "oklch(0.261 0.1013 25.28)",
  ],
  orange: [
    "oklch(0.9488 0.0265 65.68)",
    "oklch(0.8914 0.0637 63.78)",
    "oklch(0.8256 0.1045 60.43)",
    "oklch(0.7625 0.1458 56.11)",
    "oklch(0.7334 0.1852 53.41)",
    "oklch(0.6777 0.1731 49.02)",
    "oklch(0.6128 0.1604 47.66)",
    "oklch(0.5419 0.142 46.86)",
    "oklch(0.4732 0.1245 45.98)",
    "oklch(0.402 0.1043 45.78)",
  ],
  white: "oklch(1 0 0)",
  black: "oklch(0 0 0)",
} as const;
